import { FormHandle } from '@/hooks/use-form-handle.hook';
import { PolicyModel } from '@/lib/models/policy-model/policy.model';
import { QueryKey } from '@/lib/query-client';
import { getAllClassifiers } from '@/lib/services/classification.service';
import useFeature from '@/hooks/use-feature.hook';
import { FC } from 'react';
import { useQuery } from 'react-query';
import EntityControlList from './entity-control-list';
import IntentControlList from './intent-control-list';

interface Props {
  formHandle: FormHandle<PolicyModel>;
  readonly: boolean;
  defaultPolicy?: PolicyModel;
  withNotSet?: boolean;
}

const ClassifierControls: FC<Props> = ({
  formHandle,
  readonly,
  defaultPolicy,
  withNotSet = true,
}) => {
  const { hasClassifiers } = useFeature();
  const { data, refetch } = useQuery([QueryKey.ClassifiersList], () => getAllClassifiers());
  const classifiers = data || [];

  return (
    <>
      <IntentControlList
        formHandle={formHandle}
        readonly={readonly}
        defaultPolicy={defaultPolicy}
        withNotSet={withNotSet}
        classifiers={classifiers}
        refetch={refetch}
      />
      {hasClassifiers && (
        <EntityControlList
          formHandle={formHandle}
          readonly={readonly}
          defaultPolicy={defaultPolicy}
          withNotSet={withNotSet}
          classifiers={classifiers}
          refetch={refetch}
        />
      )}
    </>
  );
};

export default ClassifierControls;
